import { useEffect, useState } from 'react';

import { Level, StructureNode } from '@app/api/models/structure';
import { useQueryTable } from '@app/components/common/table/query-table';
import { useApi } from '@app/hooks';
import { Dialog } from '@app/components/common';

import { OrgStructureForm } from '../form';


export const EditDialog = ({
  open,
  levels,
  onClose,
  initial,
  onSubmit,
  onCancel,
}: {
  open: boolean;
  levels: Level[];
  onClose(): void;
  initial?: StructureNode;
  onSubmit?(): void;
  onCancel?(): void;
}) => {
  const api = useApi();
  const { refetch } = useQueryTable();
  const [parent, setParent] = useState<StructureNode | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmitClick = async () => {
    setLoading(true);
    await refetch();
    onSubmit?.();
    onClose();
    setLoading(false);
  };

  useEffect(() => { 
    if (!initial?.boss_id) {return;}
    (async () => {
      setLoading(true);

      const { data } = await api.structure.getNodes({
        filter: { 
          id: initial.boss_id.toString(),
        },
        sort: '+id',
        limit: 1,
        offset: 0,
      });
      setParent(data.data[0]);
    
      setLoading(false);
    })();
  }, [initial]);



  return <Dialog open={open}
    onClose={onClose}
    title={initial ? 'Редактирование' : 'Добавление'}
    width={800}
    loading={loading}
  >
    <OrgStructureForm
      parent={parent}
      initial={initial}
      onSubmit={onSubmitClick}
      onCancel={onCancel}
      levels={levels}
    />
  </Dialog>;
};